// Real aspect ratios come from each SVG's viewBox (W x 40), so `width` here is
// the viewBox width and `height` is 40 — this makes the reserved layout box
// match the rendered image exactly (no layout shift). CSS `h-* w-auto` then
// drives the actual size; every logo shares one height so wide wordmarks
// (WSJ 8.5:1, Institutional Investor 9.5:1) are never clamped/crushed.
const rowOne = [
  { name: "Bloomberg", src: "/images/logos/bloomberg.svg", width: 220 },
  { name: "Wall Street Journal", src: "/images/logos/wsj.svg", width: 340 },
  { name: "Forbes", src: "/images/logos/forbes.svg", width: 140 },
  { name: "CNBC", src: "/images/logos/cnbc.svg", width: 120 },
];

const rowTwo = [
  { name: "Financial Times", src: "/images/logos/financial-times.svg", width: 260 },
  { name: "CFO Brew", src: "/images/logos/cfobrew.svg", width: 180 },
  { name: "Institutional Investor", src: "/images/logos/institutional-investor.svg", width: 380 },
];

function Logo({ name, src, width }: { name: string; src: string; width: number }) {
  return (
    <img
      src={src}
      alt={name}
      width={width}
      height={40}
      className="h-3.5 sm:h-5 md:h-6 w-auto transition-opacity duration-700 select-none opacity-60 hover:opacity-100 brightness-0 invert"
      draggable={false}
    />
  );
}

export default function TrustBar() {
  return (
    <section className="py-10 sm:py-14 relative overflow-hidden bg-transparent border-b border-white/10">
      <p className="mb-6 sm:mb-8 text-center text-xs font-medium uppercase tracking-[0.2em] text-white/50">
        As seen in
      </p>
      {/* Two balanced sub-rows (4 + 3, ~equal natural width). Stacked and
          centered on all sizes, merged into one line at xl. Because each row is
          its own flex container, an out-of-space failure degrades to 4-over-3 —
          never a lone orphan. No fixed cell widths and no max-width clamp, so
          every logo keeps one uniform height regardless of how wide it is. */}
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8 flex flex-col items-center gap-y-6 sm:gap-y-8 xl:flex-row xl:justify-center xl:gap-y-0 xl:gap-x-8">
        <div className="flex flex-wrap items-center justify-center gap-x-4 sm:gap-x-6 lg:gap-x-8">
          {rowOne.map((logo) => (
            <Logo key={logo.name} {...logo} />
          ))}
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-4 sm:gap-x-6 lg:gap-x-8">
          {rowTwo.map((logo) => (
            <Logo key={logo.name} {...logo} />
          ))}
        </div>
      </div>
    </section>
  );
}
